<ng-template #titleTemplate>
  {{ title }}
</ng-template>

<ng-template #navTemplate>
  <astrobin-equipment-item-type-nav #itemTypeNavComponent></astrobin-equipment-item-type-nav>
</ng-template>

<ng-template #descriptionTemplate>
  {{
    "AstroBin's equipment database is entirely maintained by the community. Feel free to make a contribution!"
      | translate
  }}
  <a class="learn-more" href="https://welcome.astrobin.com/features/equipment-database" target="_blank">
    {{ "Learn more" }}.
  </a>
</ng-template>

<div class="page">
  <ng-container *ngIf="breakpointMdMin">
    <h1><ng-container [ngTemplateOutlet]="titleTemplate"></ng-container></h1>
    <small><ng-container [ngTemplateOutlet]="descriptionTemplate"></ng-container></small>
  </ng-container>

  <div class="row g-0 g-3">
    <div *ngIf="breakpointMdMin" class="col-md-4 col-xl-3">
      <ng-container [ngTemplateOutlet]="navTemplate"></ng-container>
    </div>

    <div class="col-md-8 col-xl-9">
      <ng-container *ngIf="items$ | async as items; else loading">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>
                {{ equipmentItemService.getPrintablePropertyName(null, EquipmentItemDisplayProperty.NAME, true) }}
              </th>
              <th>
                {{ "Users" | translate }}
              </th>
              <th>
                {{ "Images" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items.results">
              <td>
                <a
                  [queryParams]="{ 'back-on-close': true }"
                  [routerLink]="['/equipment/explorer', activeType.toLowerCase(), item.id]"
                >
                  <astrobin-equipment-item-display-name [item]="item"></astrobin-equipment-item-display-name>
                </a>
              </td>
              <td>{{ item.userCount }}</td>
              <td>{{ item.imageCount }}</td>
            </tr>
          </tbody>
        </table>

        <astrobin-nothing-here *ngIf="items.count === 0"></astrobin-nothing-here>

        <ngb-pagination
          *ngIf="items.count > items.results.length"
          [collectionSize]="items.count"
          (pageChange)="pageChange($event)"
          [(page)]="page"
        >
          <ng-template ngbPaginationPrevious>&larr;</ng-template>
          <ng-template ngbPaginationNext>&rarr;</ng-template>
        </ngb-pagination>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
